import React, { useState, useEffect } from "react";
import { getDatabase, ref, onValue, set } from "firebase/database";
import "./SubjectsPage.css";

const SubjectsPage = () => {
  const db = getDatabase();
  const [subjects, setSubjects] = useState({});
  const [newSubject, setNewSubject] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [examFilter, setExamFilter] = useState("all"); // New state for exam filter

  useEffect(() => {
    const subjectsRef = ref(db, "Subjects");
    onValue(subjectsRef, (snapshot) => {
      const data = snapshot.val();
      setSubjects(data || {});
    });
  }, [db]);

  const handleAddSubject = () => {
    if (selectedExam && selectedCategory && newSubject) {
      const updatedSubjects = {
        ...subjects,
        [selectedExam]: {
          ...subjects[selectedExam],
          [selectedCategory]: [
            ...(subjects[selectedExam]?.[selectedCategory] || []),
            newSubject,
          ],
        },
      };
      set(ref(db, "Subjects"), updatedSubjects);
      setNewSubject("");
    }
  };

  const handleDeleteSubject = (exam, category, index) => {
    const updatedSubjects = { ...subjects };
    updatedSubjects[exam][category].splice(index, 1);
    if (updatedSubjects[exam][category].length === 0) {
      delete updatedSubjects[exam][category];
    }
    if (Object.keys(updatedSubjects[exam]).length === 0) {
      delete updatedSubjects[exam];
    }
    set(ref(db, "Subjects"), updatedSubjects);
  };

  const handleEditSubject = (exam, category, index, newValue) => {
    const updatedSubjects = { ...subjects };
    updatedSubjects[exam][category][index] = newValue;
    set(ref(db, "Subjects"), updatedSubjects);
  };

  // Filter exams based on examFilter
  const filteredExams =
    examFilter === "all"
      ? Object.keys(subjects)
      : [examFilter].filter((exam) => subjects[exam]); // Only include valid exams

  return (
    <div className="subjects-page">
      <h1 className="subjects-title">Subjects Management</h1>
      <div className="subjects-filter">
        <select
          className="subjects-select"
          value={examFilter}
          onChange={(e) => setExamFilter(e.target.value)}
        >
          <option value="all">All Exams</option>
          <option value="WAEC">WAEC</option>
          <option value="POST-UTME">POSTUTME</option>
          <option value="JAMB">JAMB</option>
        </select>
      </div>
      <div className="subjects-form">
        <select
          className="subjects-select"
          value={selectedExam}
          onChange={(e) => {
            setSelectedExam(e.target.value);
            setSelectedCategory(""); // Reset category when exam changes
          }}
        >
          <option value="">Select Exam</option>
          <option value="WAEC">WAEC</option>
          <option value="POST-UTME">POSTUTME</option>
          <option value="JAMB">JAMB</option>
        </select>
        <select
          className="subjects-select"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          disabled={!selectedExam}
        >
          <option value="">Select Category</option>
          {selectedExam &&
            Object.keys(subjects[selectedExam] || {}).map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
        </select>
        <input
          className="subjects-input"
          type="text"
          placeholder="New Subject"
          value={newSubject}
          onChange={(e) => setNewSubject(e.target.value)}
        />
        <button className="subjects-button" onClick={handleAddSubject}>
          Add Subject
        </button>
      </div>
      {filteredExams.length > 0 ? (
        filteredExams.map((exam) => (
          <div key={exam} className="subjects-exam">
            <h2 className="subjects-exam-title">{exam}</h2>
            {Object.keys(subjects[exam]).map((category) => (
              <div key={category} className="subjects-category">
                <h3 className="subjects-category-title">{category}</h3>
                <ul className="subjects-list">
                  {subjects[exam][category].map((subject, index) => (
                    <li key={index} className="subjects-list-item">
                      <input
                        className="subjects-edit-input"
                        type="text"
                        value={subject}
                        onChange={(e) =>
                          handleEditSubject(
                            exam,
                            category,
                            index,
                            e.target.value
                          )
                        }
                      />
                      <button
                        className="subjects-delete-button"
                        onClick={() =>
                          handleDeleteSubject(exam, category, index)
                        }
                      >
                        Delete
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        ))
      ) : (
        <p>No subjects available for the selected exam.</p>
      )}
    </div>
  );
};

export default SubjectsPage;
